// extracted by mini-css-extract-plugin
export default {"paidPill":"EpM6ZG9uegE9GONhf3NJ","paidPillIconOnly":"ldFZmoEMz1Jpq1M7JOfy"};